export const RTL_CHARS_REGEX = /[\u0590-\u08FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;

/** Kept as one run inside text of the other direction: a Latin name in a Hebrew sentence would
 *  otherwise pull the punctuation and the words around it out of order. */
export function bidiIsolated(text: string): string {
  return `\u2068${text}\u2069`;
}

export function isRtlText(text: string): boolean {
  return RTL_CHARS_REGEX.test(text);
}
